'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var reactRouterDom = require('react-router-dom');
var DocumentBody = require('@narvar/nth-bit-document-body');
var ClaimsProviders = require('./providers/ClaimsProviders.js');
var index = require('./views/OrderLookup/index.js');
var index$1 = require('./views/ItemSelection/index.js');
var index$6 = require('./views/PackageSelection/index.js');
var index$4 = require('../../common/views/ItemPhoto/index.js');
var index$9 = require('./views/ConfirmationSummary/index.js');
var paths = require('../../paths.js');
var index$3 = require('./views/ItemQuantity/index.js');
var ClaimNavigator = require('../../common/providers/ClaimNavigator.js');
var index$5 = require('./views/ItemAdditionalInfo/index.js');
var index$8 = require('./views/PackageAdditionalInfo/index.js');
var ItemClaimSummary = require('./views/ClaimSummary/ItemClaimSummary.js');
var PackageClaimSummary = require('./views/ClaimSummary/PackageClaimSummary.js');
var index$2 = require('./views/ItemRemoveConfirmation/index.js');
var index$7 = require('./views/PackageRemoveConfirmation/index.js');
var GlobalStyleTag = require('./components/GlobalStyleTag.js');
var MerchantIsLiveCheck = require('../../common/components/MerchantIsLiveCheck.js');
var DeviceProfileProvider = require('../../common/providers/DeviceProfileProvider.js');
var ClaimsApolloProvider = require('./providers/ClaimsApolloProvider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var DocumentBody__default = /*#__PURE__*/_interopDefaultLegacy(DocumentBody);

const App = _ref => {
  let {
    config
  } = _ref;
  const Router = config.routerType === 'Hash' ? reactRouterDom.HashRouter : reactRouterDom.BrowserRouter;
  return /*#__PURE__*/React__default["default"].createElement(Router, null, /*#__PURE__*/React__default["default"].createElement(ClaimNavigator.ClaimNavigator, null, /*#__PURE__*/React__default["default"].createElement(reactRouterDom.Routes, null, /*#__PURE__*/React__default["default"].createElement(reactRouterDom.Route, {
    path: paths.ORDER_LOOKUP,
    element: /*#__PURE__*/React__default["default"].createElement(index["default"], null)
  }), /*#__PURE__*/React__default["default"].createElement(reactRouterDom.Route, {
    path: paths.ITEM_SELECTION,
    element: /*#__PURE__*/React__default["default"].createElement(index$1["default"], null)
  }), /*#__PURE__*/React__default["default"].createElement(reactRouterDom.Route, {
    path: paths.ITEM_REMOVE_CONFIRMATION,
    element: /*#__PURE__*/React__default["default"].createElement(index$2["default"], null)
  }), /*#__PURE__*/React__default["default"].createElement(reactRouterDom.Route, {
    path: paths.ITEM_QUANTITY,
    element: /*#__PURE__*/React__default["default"].createElement(index$3["default"], null)
  }), /*#__PURE__*/React__default["default"].createElement(reactRouterDom.Route, {
    path: paths.ITEM_PHOTO,
    element: /*#__PURE__*/React__default["default"].createElement(index$4["default"], null)
  }), /*#__PURE__*/React__default["default"].createElement(reactRouterDom.Route, {
    path: paths.ITEM_ADDITIONAL_INFO,
    element: /*#__PURE__*/React__default["default"].createElement(index$5["default"], null)
  }), /*#__PURE__*/React__default["default"].createElement(reactRouterDom.Route, {
    path: paths.ITEM_CLAIM_SUMMARY,
    element: /*#__PURE__*/React__default["default"].createElement(ItemClaimSummary["default"], null)
  }), /*#__PURE__*/React__default["default"].createElement(reactRouterDom.Route, {
    path: paths.PACKAGE_SELECTION,
    element: /*#__PURE__*/React__default["default"].createElement(index$6["default"], null)
  }), /*#__PURE__*/React__default["default"].createElement(reactRouterDom.Route, {
    path: paths.PACKAGE_REMOVE_CONFIRMATION,
    element: /*#__PURE__*/React__default["default"].createElement(index$7["default"], null)
  }), /*#__PURE__*/React__default["default"].createElement(reactRouterDom.Route, {
    path: paths.PACKAGE_ADDITIONAL_INFO,
    element: /*#__PURE__*/React__default["default"].createElement(index$8["default"], null)
  }), /*#__PURE__*/React__default["default"].createElement(reactRouterDom.Route, {
    path: paths.PACKAGE_CLAIM_SUMMARY,
    element: /*#__PURE__*/React__default["default"].createElement(PackageClaimSummary["default"], null)
  }), /*#__PURE__*/React__default["default"].createElement(reactRouterDom.Route, {
    path: paths.CONFIRMATION,
    element: /*#__PURE__*/React__default["default"].createElement(index$9["default"], null)
  }))));
};
const Claims = _ref2 => {
  let {
    params,
    config
  } = _ref2;
  return /*#__PURE__*/React__default["default"].createElement(ClaimsProviders["default"], {
    params: params,
    config: config
  }, /*#__PURE__*/React__default["default"].createElement(GlobalStyleTag["default"], null), /*#__PURE__*/React__default["default"].createElement(DocumentBody__default["default"], null), /*#__PURE__*/React__default["default"].createElement(MerchantIsLiveCheck["default"], null, /*#__PURE__*/React__default["default"].createElement(App, {
    config: config
  })));
};
const ClaimsWithApollo = _ref3 => {
  let {
    params,
    config
  } = _ref3;
  return /*#__PURE__*/React__default["default"].createElement(DeviceProfileProvider.DeviceProfileProvider, null, /*#__PURE__*/React__default["default"].createElement(ClaimsApolloProvider.ClaimsApolloProvider, {
    config: config
  }, /*#__PURE__*/React__default["default"].createElement(Claims, {
    params: params,
    config: config
  })));
};

exports.Claims = Claims;
exports["default"] = ClaimsWithApollo;
